import React, {useState, useEffect} from 'react';
import {MiPerfilInferior} from './MiPerfilInferior';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {ModalesMiPerfil} from './ModalesMiPerfil';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import axios from 'axios';
import {animateScroll as scroll} from 'react-scroll';
import {useNavigate} from 'react-router-dom';

export const ContentBodyMiPerfil = (props) => {
	/* Using the useSessionStore hook to get the UsuarioContext from the session storage. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const [UsuarioCambiar, setUsuarioCambiar] = useState({
		...Usuario.cliente,
		email: Usuario.cliente.usuario.email,
	});
	const [FotoPerfilCambiar, setFotoPerfilCambiar] = useState();
	const [modalBorrrarCuenta, setModalBorrrarCuenta] = useState(false);
	const [modalGuardarCambios, setModalGuardarCambios] = useState(false);
	const {setGuardarCambios, setBorrarCuenta, MenuLateralAux, chageMenuLateralAux, setShowToast} = props;
	const [ModalCambiarFotoPerfil, setModalCambiarFotoPerfil] = useState(false);
	const [ModalFotoCambiadaOK, setModalFotoCambiadaOK] = useState(false);
	const [ModalFotoCambiadaNoOK, setModalFotoCambiadaNoOK] = useState(false);
	const [ErroresFormulario, setErroresFormulario] = useState([]);
	/* Creating a state variable called ModalErrores and setting it to false. */
	const [ModalErrores, setModalErrores] = useState(false);

	const [modificar, setModificar] = useState(false);

	const navigate = useNavigate();

	// const get_usuario = async () =>{
	//   await axios({
	//     method: "get",
	//     url: window.ipdirection + "clienteByCliente/",
	//     headers: {
	//       Authorization: "Bearer " + Usuario.access,
	//     },
	//   })
	//     .then((response) => {
	//       console.log('Response ',response.data[0]['usuario']['email'])
	//     })
	//     .catch((error) => {
	//       console.log(error);
	//     });
	// }

	useEffect(() => {
		scroll.scrollToTop();
		//get_usuario()
	}, []);

	const actualizarFoto = () => {
		let correct = false;
		if (FotoPerfilCambiar !== null) {
			if (FotoPerfilCambiar !== undefined) {
				if (FotoPerfilCambiar.fotoPerfil !== null) {
					if (FotoPerfilCambiar.fotoPerfil !== undefined) {
						if (
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/jpg' ||
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/png' ||
							FotoPerfilCambiar.fotoPerfil.type.toString() === 'image/jpeg'
						) {
							selectFotoPerfil(Usuario, 1);
							correct = true;
						}
					}
				}
			}
		}
		if (!correct) {
			setModalFotoCambiadaNoOK(true);
		}
	};
	/**
	 * It gets the image of the user from the database and then calls the function colocarFoto()
	 * @param {Object} usuario - The user object containing the access token and user data.
	 */
	const selectFotoPerfil = (usuario, funtion) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilCliente/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
		})
			.then((response) => {
				console.log(response, funtion);
				if (funtion === 0) {
					return colocarFoto(usuario, response.data[0]);
				} else {
					return borrarFotoAntigua(response.data[0]);
				}
			})
			.catch((error) => {
				try {
					cambiarFotoPerfil();
				} catch {
					setErroresFormulario(['Error al cargar la foto de perfil 2 ' + error]);
					setModalErrores(true);
				}
			});
	};

	const colocarFoto = (usuario, foto) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'imagenPerfilCliente/' + foto.id.toString() + '/',
			headers: {
				Authorization: 'Bearer ' + usuario.access,
			},
			responseType: 'blob',
		})
			.then((response) => {
				setUsuario({
					...usuario,
					fotoPerfil: URL.createObjectURL(response.data),
				});
			})
			.catch((error) => {
				setErroresFormulario(['Error al cargar la foto de perfil 1' + error.toString()]);
				setModalErrores(true);
			});
	};
	const borrarFotoAntigua = (foto) => {
		axios({
			url: window.ipdirection + 'imagenPerfilCliente/' + foto.id.toString() + '/',
			method: 'delete',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				cambiarFotoPerfil();
			})
			.catch((error) => {
				setErroresFormulario(['Fallo al actualizar su foto de perfil' + error.toString()]);
				setModalErrores(true);
			});
	};

	const cambiarFotoPerfil = () => {
		const formData = new FormData();
		const imagenOriginal = new Image(); // Crear un objeto imagen
		imagenOriginal.src = URL.createObjectURL(FotoPerfilCambiar.fotoPerfil); // Cargar la imagen en el objeto

		// Esperar a que la imagen se cargue
		imagenOriginal.onload = () => {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			// Definir la resolución deseada
			const ancho = 300; // ancho deseado
			const alto = 300; // alto deseado

			canvas.width = ancho;
			canvas.height = alto;

			// Set image scale
			let scaleFactor = Math.max(
				canvas.width / imagenOriginal.width,
				canvas.height / imagenOriginal.height
			);

			// Finding the new width and height based on the scale factor
			let newWidth = imagenOriginal.width * scaleFactor;
			let newHeight = imagenOriginal.height * scaleFactor;

			// get the top left position of the image
			// in order to center the image within the canvas
			let x = canvas.width / 2 - newWidth / 2;
			let y = canvas.height / 2 - newHeight / 2;

			ctx.drawImage(imagenOriginal, x, y, newWidth, newHeight);

			canvas.toBlob((blob) => {
				//formData.append("documento", File);
				formData.append('imagen', blob, Usuario.cliente.nombre + '.png');
				formData.append('nombre', 'FotoPerfil-' + Usuario.cliente.nombre);
				//formData.append("nombre", "Prueba");
				formData.append('usuario_id', Usuario.cliente.usuario.id);

				axios
					.post(window.ipdirection + 'imagenPerfilCliente/', formData, {
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
					})
					.then((response) => {
						selectFotoPerfil(Usuario, 0);
						setModalCambiarFotoPerfil(false);
						setModalFotoCambiadaOK(true);
					})
					.catch((error) => {
						setErroresFormulario([
							'Error al enviar la foto de perfil' + error.toString(),
						]);
						setModalErrores(true);
					});
			});
		};
	};
	const onInputChange = (event) => {
		setUsuarioCambiar({
			...UsuarioCambiar,
			[event.target.name]: event.target.value,
		});
	};

	const guardarCambios = async () => {
		console.log(Usuario.cliente.usuario['id']);

		let data = UsuarioCambiar;

		await axios({
			method: 'put',
			url: window.ipdirection + 'modificarUsuario/' + Usuario.cliente.usuario['id'] + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: data,
		})
			.then((response) => {
				setModalGuardarCambios(false);
				setModificar(false);
				setShowToast(true)
				var inputs = document.getElementsByClassName('inputModificar');
				for (var i = 0; i < inputs.length; i++) {
					inputs[i].disabled = true;
				}
			})
			.catch((error) => {});
	};

	const eliminarPerfil = () => {
		axios({
			method: 'delete',
			url: window.ipdirection + 'eliminarUsuario/' + UsuarioCambiar.usuario['id'] + '/',
		})
			.then((response) => {
				// Actualiza el estado de ListaCategorias con los datos de las categorías obtenidas.
				setModalBorrrarCuenta(false);
				navigate('/login');
				setUsuario({
					tipo: 'noRegistrado',
					userName: '',
					email: '',
					imagen: '',
					access: '',
					refresh: '',
				});
			})
			.catch((error) => {});
	};

	return (
		<>
			<MenuLateralAB
				seleccionado={11}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='ContentBodyMiPerfil'>
				<div className='content-miPerfil'>
					<div className='miPerfilSuperior'>
						<div className='centrador divImagenPerfilFondo'>
							<img
								src={Usuario.fotoPerfil}
								className='imagenPerfilMiPerfil '
								alt={Usuario.cliente.nombre + ' ' + Usuario.cliente.apellidos}
							/>
							<div className='iconoCambioFotoPerfil centrador'>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									fill='currentColor'
									className='bi bi-plus-circle-fill'
									viewBox='0 0 16 16'
									onClick={() => setModalCambiarFotoPerfil(true)}
								>
									<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
								</svg>
							</div>
						</div>
						<div className='nombreUsuarioMiPerfil centrador'>
							{Usuario.cliente.nombre + ' ' + Usuario.cliente.apellidos}
						</div>
					</div>
					<MiPerfilInferior
						onInputChange={onInputChange}
						modalBorrrarCuenta={modalBorrrarCuenta}
						setModalBorrrarCuenta={setModalBorrrarCuenta}
						modificar={modificar}
						setModificar={setModificar}
						setModalGuardarCambios={setModalGuardarCambios}
						UsuarioCambiar={UsuarioCambiar}
					/>
				</div>
				<ModalesMiPerfil
					modalBorrrarCuenta={modalBorrrarCuenta}
					setModalBorrrarCuenta={setModalBorrrarCuenta}
					setModalGuardarCambios={setModalGuardarCambios}
					modalGuardarCambios={modalGuardarCambios}
					guardarCambios={guardarCambios}
					eliminarPerfil={eliminarPerfil}
				/>
			</div>

			<Modal
				centered={true}
				isOpen={ModalFotoCambiadaNoOK}
			>
				<ModalHeader>
					<div className='titulo-modal'>Mi Empresa</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						Ups... Parece que no se puede subir la foto
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centradorRight'>
						<div
							className='button'
							onClick={() => setModalFotoCambiadaNoOK(false)}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalCambiarFotoPerfil}
			>
				<ModalHeader>
					<div className='titulo-modal'>Actualiza la imagen de tu perfil empresarial</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						<p>Sube una nueva foto para darle un aspecto más moderno y profesional a tu perfil.</p>
						<input
							type='file'
							className='inputTextUsuario inputFile'
							accept='image/*'
							onChange={(e) =>
								setFotoPerfilCambiar({
									...setFotoPerfilCambiar,
									fotoPerfil: e.target.files[0],
								})
							}
						/>
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<div
							className='buttonB'
							onClick={() => setModalCambiarFotoPerfil(false)}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='button'
							onClick={() => actualizarFoto()}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>

			<Modal
				centered={true}
				isOpen={ModalFotoCambiadaOK}
			>
				<ModalHeader>
					<div className='titulo-modal'>Mi Empresa</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						¡Tu foto de perfil de ha sido actualizada correctamente!
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='centradorRight'>
						<div
							className='button'
							onClick={() => setModalFotoCambiadaOK(false)}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
			<Modal
				centered={true}
				isOpen={ModalErrores}
			>
				<ModalHeader>
					<div className='titulo-modal'>
						Uno o varios datos del formulario de registro no son validos
					</div>
				</ModalHeader>
				<ModalBody>
					<div className='descripcion-servicio descripcion-modal'>
						{ErroresFormulario.map((error) => (
							<div> - {error} </div>
						))}
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='button-modal-registroEmpresa centrador'>
						<div
							className='button'
							onClick={() => {
								setModalErrores(false);
								setErroresFormulario([]);
							}}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
